// src/features/owner/sections/system/BackupsSection.tsx — prototype snapshot list + create.
import { useOwnerAction } from '@/hooks/useOwnerAction';
import { Button } from '@/ui';
import { OwnerPanel, EmptyState } from '../../components';

export function BackupsSection() {
  const action = useOwnerAction();
  return (
    <OwnerPanel
      title="Backups (prototype, not yet wired)"
      action={
        <Button variant="primary" onClick={() => action.logAction('create-backup', 'system')}>
          Create backup
        </Button>
      }
    >
      <EmptyState icon="archive" message="No backups yet" />
    </OwnerPanel>
  );
}
